(function () {
  const MANAGER_KEY = 'NouvacAnnouncementCountdownManager';
  const ROOT_SELECTOR = '[data-announcement-bar-root]';
  const COUNTDOWN_SELECTOR = '.announcement-bar__countdown[data-countdown-enabled="true"]';

  if (window[MANAGER_KEY]) {
    window[MANAGER_KEY].init(document);
    return;
  }

  const controllers = new Map();

  const formatCountdown = (secondsRemaining) => {
    const safeSeconds = Math.max(0, secondsRemaining);
    const days = Math.floor(safeSeconds / 86400);
    const hours = Math.floor((safeSeconds % 86400) / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;

    const pad = (value) => String(value).padStart(2, '0');
    return `${pad(days)}j ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
  };

  const parseFixedOffsetDate = (dateString, utcOffset) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(dateString || '');
    if (!match) return NaN;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const hour = Number(match[4]);
    const minute = Number(match[5]);
    const second = Number(match[6] || 0);
    const offsetHours = Number(utcOffset || 0);

    return Date.UTC(year, month, day, hour, minute, second) - offsetHours * 3600000;
  };

  const parseTargetTimestamp = (node) => {
    const endTime = node.dataset.endTime || '';
    const timezone = node.dataset.timezone || 'visitor';
    const utcOffset = Number(node.dataset.utcOffset || 0);

    if (!endTime) return NaN;

    if (timezone === 'fixed') {
      return parseFixedOffsetDate(endTime, utcOffset);
    }

    return new Date(endTime).getTime();
  };

  const getMatches = (scope, selector) => {
    if (!scope) return [];
    const matches = scope.matches?.(selector) ? [scope] : [];
    return matches.concat(Array.from(scope.querySelectorAll?.(selector) || []));
  };

  const isActiveRoot = (root) => {
    const sectionRoot = root.closest('.announcement-bar-section');
    if (!sectionRoot || !root.isConnected) return false;
    if (root.hidden || root.getAttribute('aria-hidden') === 'true') return false;
    return !sectionRoot.hidden && sectionRoot.getAttribute('aria-hidden') !== 'true';
  };

  const initCountdown = (node) => {
    if (controllers.has(node)) return;

    const expiredText = node.dataset.expiredText || 'Offre expirée';
    const endBehavior = node.dataset.endBehavior || 'expired_text';
    const repeatHours = Number(node.dataset.repeatHours || 0);
    let targetTime = parseTargetTimestamp(node);

    const controller = {
      intervalId: null,
      stop() {
        if (this.intervalId === null) return;
        clearInterval(this.intervalId);
        this.intervalId = null;
      },
      destroy() {
        this.stop();
        controllers.delete(node);
      }
    };
    controllers.set(node, controller);

    if (Number.isNaN(targetTime)) {
      node.textContent = node.dataset.expiredText || 'Offre expirée';
      return;
    }

    const update = () => {
      if (!node.isConnected) {
        controller.destroy();
        return false;
      }

      const now = Date.now();
      let remaining = Math.floor((targetTime - now) / 1000);

      if (remaining <= 0) {
        if (endBehavior === 'restart' && repeatHours > 0) {
          const repeatMs = repeatHours * 3600000;
          while (targetTime <= now) targetTime += repeatMs;
          remaining = Math.floor((targetTime - now) / 1000);
        } else if (endBehavior === 'next_day') {
          while (targetTime <= now) targetTime += 24 * 3600000;
          remaining = Math.floor((targetTime - now) / 1000);
        } else if (endBehavior === 'hide') {
          node.style.display = 'none';
          controller.stop();
          return false;
        } else {
          node.textContent = expiredText;
          controller.stop();
          return false;
        }
      }

      node.textContent = formatCountdown(remaining);
      return true;
    };

    if (update()) {
      controller.intervalId = setInterval(update, 1000);
    }
  };

  const init = (scope = document) => {
    getMatches(scope, ROOT_SELECTOR)
      .filter(isActiveRoot)
      .forEach((root) => root.querySelectorAll(COUNTDOWN_SELECTOR).forEach(initCountdown));
  };

  const destroy = (scope) => {
    Array.from(controllers.entries()).forEach(([node, controller]) => {
      if (scope === node || scope?.contains?.(node)) {
        controller.destroy();
      }
    });
  };

  const manager = Object.freeze({ init, destroy });
  window[MANAGER_KEY] = manager;

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      destroy(event.target);
      getMatches(event.target, ROOT_SELECTOR).forEach((root) => root.remove());
    });
  }

  init(document);
})();
